import type { IconProps } from '../types/IconProps.ts';
export const Meh: IconProps = {
    name: 'Meh',
    children: [
        `<path d="M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20M7 15h10" />`,
        `<path d="M8 10.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M16 10.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1" />`,
    ]
};